<template>
    <div v-if="is_load" style="padding-top: 1rem;">
        <navTitle
                :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Lucky jackpot'"></navTitle>
        <div class="is_open" v-if="parseInt(is_open)!==1">
            Not yet open
        </div>
        <div v-else>
            <div v-if="!not_drawn" class="tip" @click="getAllLuckyList">
                Past winners: ID{{luck_id}} Get bonus ₱{{win_award_num|MoneyFormat}}
            </div>
            <div class="c">
                <div class="title">Activity time</div>
                <div class="content">{{s_date}} ~ {{e_date}}</div>
                <div class="title">Bonus amount</div>
                <div class="content">₱{{award_num | MoneyFormat}}</div>
                <div class="title">Event number</div>
                <div class="content">{{issue}}</div>
                <div class="title">Rule of activity</div>
                <div class="content" v-html="join_rule"></div>
                <div class="title">Current consumption progress</div>
                <div class="content">
                    <progress :value="progress_value" max="100" style="width: 100%"/>
                    <div class="progress-amount">{{consumption}}/{{spend_amount}}</div>
                </div>
                <div v-if="!is_join" class="google-authenticator-btn bg-color-blue" @click="joinLucky">
                    <div>
                        <b>Join now</b>
                    </div>
                </div>
                <div v-else class="google-authenticator-btn bg-color-blue is_join">
                    <div>
                        <b>Joined</b>
                    </div>
                </div>
            </div>
            <div class="lucky-list title">My winning record</div>
            <div class="none-list" v-if="lucky_list.length===0">
                No winning record
            </div>
            <div class="lucky-list-data" v-else>
                <table style="width: 100%;border: 1px;text-align: center;height: 100%;">
                    <tr>
                        <td>Issue</td>
                        <td>Award</td>
                        <td>Operate</td>
                    </tr>
                    <tr v-for="v in lucky_list">
                        <td>{{v.issue}}</td>
                        <td>{{v.award_num}}</td>
                        <td>
                            <button v-if="v.receive===0" class="btn bg-color-blue" @click="luckyRedeem(v.issue)">
                                Receive
                            </button>
                            <button v-else class="btn is_join">Received</button>
                        </td>
                    </tr>
                </table>
            </div>
            <div style="height: 50px"></div>
            <div id="forPop" v-if="all_list" @click="bgClose"></div>
            <div class="all-award-list" v-if="all_list">
                <table style="width: 90%;border: 1px;text-align: center;margin-left: 5%;">
                    <tr style="background: #00c3f9;color: #fff;font-weight: bold;height: 50px">
                        <td>Date</td>
                        <td>ID</td>
                        <td>Award</td>
                    </tr>
                    <tr style="height: 50px" v-for="v in all_lucky_list">
                        <td>{{v.date}}</td>
                        <td>{{v.uid}}</td>
                        <td>₱{{v.award_num | MoneyFormat}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import navTitle from "@components/navTitle";
    import {getAwardInfo, joinLucky, getLuckyList, getAllLuckyList, LuckyRedeem} from "@api/activity";
    import {DebounceBy} from "@api/user";

    export default {
        name: "LuckyAward",
        components: {
            navTitle
        },
        data() {
            return {
                phone: '62*****33',
                nickname: 'xc****ds',
                s_date: '',
                e_date: '',
                award_num: '',
                win_award_num: '',
                spend_amount: '',
                join_rule: '',
                is_open: '',
                is_load: false,
                issue: '',
                is_join: false,
                all_list: false,
                luck_id: '',
                progress_value: 0,
                consumption: 0,
                not_drawn: true,
                lucky_list: [],
                all_lucky_list: []
            }
        },
        created() {
            this.getLuckInfo()
            this.getLuckyList()
        },
        methods: {
            getLuckyList() {
                let that = this;
                getLuckyList().then(res => {
                    that.lucky_list = res.data
                })
            },
            getAllLuckyList() {
                this.all_list = true
                let that = this
                getAllLuckyList().then(res => {
                    that.all_lucky_list = res.data
                    console.log(that.all_lucky_list)
                })
            },
            getLuckInfo() {
                let that = this
                getAwardInfo().then(res => {
                    that.s_date = res.data.s_date
                    that.e_date = res.data.e_date
                    that.phone = res.data.phone
                    that.nickname = res.data.nickname
                    that.award_num = res.data.award_num
                    that.spend_amount = res.data.spend_amount
                    that.join_rule = res.data.join_rule
                    that.issue = res.data.issue
                    that.is_join = res.data.is_join
                    that.is_open = res.data.is_open
                    that.not_drawn = res.data.not_drawn
                    that.consumption = res.data.consumption
                    that.luck_id = res.data.luck_id
                    that.win_award_num = res.data.win_award_num
                    that.is_load = true
                    that.progress_value = Math.ceil((res.data.consumption / res.data.spend_amount) * 100)
                    // console.log(res.data.consumption)
                    // console.log(res.data.spend_amount)
                    // console.log(that.progress_value)
                })
            },
            joinLucky() {
                let that = this
                joinLucky().then(res => {
                    that.is_join = true
                    that.$dialog.toast({mes: res.msg});
                }).catch(err => {
                    that.$dialog.error(err.msg);
                })
            },
            luckyRedeem: DebounceBy(function (v) {
                let that = this;
                LuckyRedeem({issue: v}).then(res => {
                    that.$dialog.toast({mes: res.msg});
                }).catch(err => {
                    that.$dialog.error(err.msg);
                })
            }, 3000),
            bgClose() {
                this.all_list = false
            }
        }
    }
</script>

<style scoped>
    .all-award {
        text-align: right;
        margin-top: -.3rem;
        position: absolute;
        width: 98%;
    }

    .is_open {
        text-align: center;
        font-size: .3rem;
        color: #ddd;
        font-weight: bold;
        padding: .3rem;
    }

    .tip {
        text-align: center;
        font-size: 16px;
        padding: .1rem 0;
        /*width: 100%;*/
        background: rgba(254, 211, 44, 0.6);
        /*z-index: 10;*/
        /*position: fixed;*/
    }

    .c {
        background-color: #f5f5f5;
        /*margin-top: .6rem;*/
        padding: .1rem;
    }

    .title {
        font-size: .25rem;
        color: #333333;
        /*font-weight: bold;*/
    }

    .content {
        margin: .1rem 0;
        padding: .1rem;
        background-color: #fff;
    }

    .google-authenticator-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .bg-color-blue {
        background-color: #00c3f9 !important;
        margin-bottom: .2rem;
    }

    .is_join {
        background-color: #ddd !important;
    }

    .lucky-list {
        color: #333333;
        padding: .2rem;
    }

    .none-list {
        text-align: center;
        font-size: .3rem;
        color: #eee;
        font-weight: bold;
        padding-bottom: .5rem;
    }

    .lucky-list-data {
        width: 100%;
        background: #fff;
        padding-bottom: .5rem;
    }

    .btn {
        margin-top: .1rem;
        border-radius: .1rem;
        padding: .1rem;
        text-align: center;
        color: #fff;
        width: 80px;
    }

    /* IE10 */
    progress {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    /* Firefox */
    progress::-moz-progress-bar {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    /* Chrome */
    progress::-webkit-progress-value {
        height: 7px;
        background-color: #00c3f9 !important;
    }

    .progress-amount {
        font-size: .25rem;
        margin-top: .1rem;
        text-align: right;
    }

    #forPop {
        z-index: 999;
        width: 100%;
        height: 1000px;
        top: 0px;
        left: 0px;
        position: absolute;
        /*因为IE不支持opacity 所以用filter 为了兼容两个都写*/
        filter: Alpha(opacity=60);
        opacity: 0.6;
        background: #000000;
    }

    .all-award-list {
        z-index: 1000;
        background-color: #fff;
        width: 350px;
        height: 370px;
        border-radius: 5px;
        /*border: #888888 2px solid;*/
        position: fixed;
        left: 50%;
        top: 50%;
        margin-top: -210px;
        margin-left: -175px;
        padding-top: 10px;
    }
</style>